<div class="admin-wrapper" [class.sidebar-collapsed]="isSidebarCollapsed">
  <div class="sidebar-backdrop" *ngIf="isMobileDrawerOpen" (click)="toggleSidebar()" aria-hidden="true"></div>
  <aside class="admin-sidebar" id="admin-sidebar">
    <div class="sidebar-header">
      <a class="brand-logo" routerLink="/dashboard" aria-label="Med Mentor administration home" title="Med Mentor administration home">
        <img src="assets/official-logo.png" alt="Med Mentor Logo" class="logo-img" />
        <span class="brand-title" *ngIf="showSidebarLabels">Med Mentor Administration</span>
      </a>
      <button class="collapse-toggle" type="button" (click)="toggleSidebar()" title="Réduire/Agrandir le menu" [attr.aria-label]="isMobileViewport ? 'Fermer le menu' : (isSidebarCollapsed ? 'Agrandir le menu' : 'Réduire le menu')" aria-controls="admin-sidebar" [attr.aria-expanded]="isMobileViewport ? isSidebarCollapsed : !isSidebarCollapsed">
        <ion-icon aria-hidden="true" [name]="isMobileViewport ? 'close-outline' : (isSidebarCollapsed ? 'chevron-forward-outline' : 'chevron-back-outline')"></ion-icon>
      </button>
    </div>

    <nav class="sidebar-nav" aria-label="Administration">
      <div class="nav-section-title" *ngIf="showSidebarLabels">ADMINISTRATION</div>
      <a *ngFor="let item of visibleNavItems" [routerLink]="item.url" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" ariaCurrentWhenActive="page" class="nav-item" [title]="item.title" [attr.aria-label]="showSidebarLabels ? null : item.title">
        <ion-icon [name]="item.icon" class="nav-icon" aria-hidden="true"></ion-icon>
        <span class="nav-text" *ngIf="showSidebarLabels">{{ item.title }}</span>
      </a>
    </nav>

    <div class="sidebar-footer" *ngIf="showSidebarLabels">
      <div class="user-card">
        <div class="user-avatar"><ion-icon name="person-circle-outline" aria-hidden="true"></ion-icon></div>
        <div class="user-info"><div class="user-name">{{ userProfile.name }}</div><div class="user-role">{{ userProfile.role }}</div></div>
      </div>
      <button class="account-password-btn" type="button" (click)="openPasswordDialog()">
        <ion-icon name="key-outline" aria-hidden="true"></ion-icon><span>Change password</span>
      </button>
      <button class="logout-btn" type="button" (click)="logout()" title="Déconnexion">
        <ion-icon name="log-out-outline" aria-hidden="true"></ion-icon><span>Déconnexion</span>
      </button>
    </div>
  </aside>

  <main class="admin-main">
    <header class="admin-header">
      <div class="header-left">
        <button class="mobile-menu-btn" type="button" (click)="toggleSidebar()" aria-label="Toggle navigation menu" aria-controls="admin-sidebar" [attr.aria-expanded]="isMobileDrawerOpen"><ion-icon name="menu-outline" aria-hidden="true"></ion-icon></button>
        <div class="search-box"><ion-icon name="search-outline" class="search-icon" aria-hidden="true"></ion-icon><input type="search" placeholder="Rechercher des utilisateurs, modules, spécialités..." aria-label="Rechercher" class="search-input" /></div>
      </div>
      <div class="header-right">
        <!-- Live Background Upload Badge -->
        <a routerLink="/attachments" class="upload-status-badge" *ngIf="activeUploadsCount > 0" title="Background upload active. Click to view queue.">
          <ion-icon name="cloud-upload-outline" class="spin-icon" aria-hidden="true"></ion-icon>
          <span>Uploading {{ activeUploadsCount }} file{{ activeUploadsCount > 1 ? 's' : '' }} ({{ overallUploadProgress }}%)</span>
        </a>
        <div class="header-profile"><div class="profile-avatar"><ion-icon name="person-circle-outline" aria-hidden="true"></ion-icon></div><div class="profile-meta"><span class="profile-name">{{ userProfile.name }}</span><span class="profile-email">{{ userProfile.email }}</span></div></div>
      </div>
    </header>
    <router-outlet></router-outlet>
  </main>
</div>

<div class="password-dialog-backdrop" *ngIf="isPasswordDialogOpen" (click)="closePasswordDialog()">
  <section class="password-dialog" role="dialog" aria-modal="true" aria-labelledby="password-dialog-title" (click)="$event.stopPropagation()">
    <header>
      <h2 id="password-dialog-title">Change password</h2>
      <button type="button" class="dialog-close" (click)="closePasswordDialog()" [disabled]="isChangingPassword" aria-label="Close">×</button>
    </header>
    <label>Current password<input [(ngModel)]="currentPassword" type="password" autocomplete="current-password" (keyup.enter)="changeOwnPassword()"></label>
    <label>New password<input [(ngModel)]="newPassword" type="password" autocomplete="new-password" (keyup.enter)="changeOwnPassword()"></label>
    <label>Confirm new password<input [(ngModel)]="confirmPassword" type="password" autocomplete="new-password" (keyup.enter)="changeOwnPassword()"></label>
    <p class="password-dialog-error" *ngIf="passwordError" role="alert">{{ passwordError }}</p>
    <footer>
      <button type="button" class="dialog-cancel" (click)="closePasswordDialog()" [disabled]="isChangingPassword">Cancel</button>
      <button type="button" class="dialog-submit" (click)="changeOwnPassword()" [disabled]="isChangingPassword">{{ isChangingPassword ? 'Changing…' : 'Change password' }}</button>
    </footer>
  </section>
</div>
